import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import './index.css';
import { API_BASE_URL } from './services/api';
import AppLayout from "./components/AppLayout";
import EventPage from "./pages/EventPage";
import EventDetailPage from "./pages/EventDetailPage";
import Landing from './pages/Landing';
import LoginPage from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import PlacePage from "./pages/PlacePage";
import UsersPage from "./pages/UsersPage";
import UsersListPage from "./pages/UsersListPage";
import AdminPage from "./pages/AdminPage";
import SettingsPage from "./pages/SettingsPage";
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<Landing/>}/>
        <Route path="/login" element={<LoginPage domain={API_BASE_URL} login={true}/>}/>
        <Route path="/registration" element={<LoginPage domain={API_BASE_URL} login={false}/>}/>
        <Route element={<AppLayout/>}>
          <Route path="/reset" element={<ResetPassword/>}/>
          <Route path="/events" element={<EventPage/>}/>
          <Route path="/event/:id" element={<EventDetailPage/>}/>
          <Route path="/place" element={<PlacePage/>}/>
          <Route path="/users" element={<UsersListPage/>}/>
          <Route path="/diary" element={<UsersPage/>}/>
          <Route path="/admin" element={<AdminPage/>}/>
          <Route path="/settings" element={<SettingsPage/>}/>
        </Route>
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();